import request from '@/utils/request'

export function getHistory() {
  return request({
    url: 'eteraz/get',
    method: 'post'
  })
}

export function save(lesReg, token, comment, k_cycle) {
  return request({
    url: 'eteraz/save',
    method: 'post',
    data: { LesRegID: lesReg, HashToken: token, Comment: comment, K_Cycle: k_cycle }
  })
}




